/* eslint-disable */
import { Metrics, Colors, Fonts } from '../../Themes'
import { StyleSheet, Dimensions } from 'react-native'

const screenDimensions = Dimensions.get("window")
const screenWidth = screenDimensions.width
const isIPhoneSE = (screenWidth === 320.0)
const containerDimension = isIPhoneSE ? 80 : 137

export default StyleSheet.create({
    container: {
        justifyContent: 'center',
        alignItems: 'center',
        height: containerDimension,
    },
    coverContainer: {
        position: 'absolute',
        left: '-25%',
        width: '150%',
        height: containerDimension,
    },
    cover: {
        height: containerDimension,
        opacity: 0.5,
    },
})
